import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import { Typography, Button, Image } from "antd";
import "./Tokens.css";
import cryptoken from "../../assets/coinAnimations/crypto_1_11zon.png";
import left from "../../assets/coinAnimations/iCrypto-min.png";
import {
  baseCEXURL,
  baseDEXURL,
  decodeJWT,
  getUserShortToken,
} from "../../services/api";
import cryptoSpin from "../../assets/coinAnimations/INDEXX-CRYPTO.gif";
import { useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
const { Text } = Typography;

const useStyles = makeStyles((theme: any) => ({
  disclaimerContainer: {
    maxWidth: "1500px",
    margin: "auto",
    padding: "20px",
    marginTop: "100px",
  },
  heading: {
    fontSize: "12px",
    marginBottom: "10px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  subheading: {
    fontSize: "11px",
    marginBottom: "12px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  text: {
    fontSize: "10px",
    lineHeight: "1.5",
    marginBottom: "16px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "10px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  listItem: {
    fontSize: "10px",
    lineHeight: "1.5",
    marginBottom: "6px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  link: {
    textDecoration: "none",
    color: theme.palette.text.secondary,
  },
}));

const IndexxCrypto = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const classes = useStyles();

  const [shortToken, setShortToken] = useState(null);

  const Disclaimer = () => (
    <div className={classes.disclaimerContainer}>
      <h1 className={classes.heading}>INXC Asset Wallet Disclaimer</h1>
      <p className={classes.text}>
        This INXC Asset Wallet Disclaimer ("Disclaimer") is issued by <strong>Indexx.ai</strong> (the "Company") and applies to all users ("User" or "You") holding <strong>INXC</strong> within the Company's platform. By using the Company's asset wallet and holding INXC, you agree to the terms and limitations outlined in this Disclaimer.
      </p>
     
      <h2 className={classes.subheading}>1. INXC Withdrawal Restrictions</h2>
      <h3 className={classes.subheading}>1.1 Lock-In Period</h3>
      <p className={classes.text}>
        All INXC held within the Company's platform are <strong>subject to a mandatory lock-in period</strong> until the Company's <strong>Initial Coin Offering (ICO)</strong> or formal <strong>public launch</strong>.<br /><br />
        <ul className={classes.list}>
          <li className={classes.listItem}><strong>During this period, INXC cannot be withdrawn, sold, exchanged, or converted</strong> into fiat, other cryptocurrencies, or third-party assets.</li>
          <li className={classes.listItem}>This restriction applies <strong>regardless of account status, location, or investment duration</strong>.</li>
        </ul>
      </p>
      <h3 className={classes.subheading}>1.2 INEX Auto-Increment Policy</h3>
      <p className={classes.text}>
        The native INEX token is programmed to <strong>automatically increase in value by $0.25 every quarter</strong> (90-day period) until the Company goes public or launches its ICO. This increment is applied to the internal valuation and reflected across all INEX balances held on the platform.
        <ul className={classes.list}>
          <li className={classes.listItem}>This auto-increment feature is <strong>non-compounding</strong> and is <strong>automated</strong> based on a calendar schedule.</li>
          <li className={classes.listItem}>This policy does not imply or guarantee market liquidity at the incremented value until post-ICO or public launch.</li>
        </ul>
      </p>
      <h3 className={classes.subheading}>1.3 Acknowledgment of Risk</h3>
      <p className={classes.text}>By holding INXC, you acknowledge and accept the following risks:</p>
      <ul className={classes.list}>
        <li className={classes.listItem}><strong>Regulatory Risks:</strong> Legal or policy changes may impact your ability to use or convert INXC in the future.</li>
        <li className={classes.listItem}><strong>Market Volatility:</strong> Valuations may fluctuate and are not guaranteed.</li>
        <li className={classes.listItem}><strong>Operational Risks:</strong> Technical issues, platform updates, or unforeseen disruptions may impact access to or performance of the asset wallet.</li>
      </ul>
     
      <h2 className={classes.subheading}>2. Limitation of Liability</h2>
      <h3 className={classes.subheading}>2.1 No Guarantee of Value</h3>
      <p className={classes.text}>
        The Company makes <strong>no representations or warranties</strong> regarding the future valuation or liquidity of INXC, including INEX or any other Indexx-issued asset. Market pricing, future listings, or token utility are <strong>not guaranteed</strong>.
      </p>
      <h3 className={classes.subheading}>2.2 Security and Account Responsibility</h3>
      <p className={classes.text}>
        Users are <strong>solely responsible</strong> for maintaining the security and confidentiality of their login credentials and account data.
        <ul className={classes.list}>
          <li className={classes.listItem}>Indexx.ai is <strong>not liable</strong> for any loss resulting from:
            <ul className={classes.list}>
              <li className={classes.listItem}>Unauthorized access</li>
              <li className={classes.listItem}>Account breaches</li>
              <li className={classes.listItem}>User negligence or failure to use available security features</li>
            </ul>
          </li>
        </ul>
      </p>
     
      <h2 className={classes.subheading}>3. Governing Law & Dispute Resolution</h2>
      <ul className={classes.list}>
        <li className={classes.listItem}>This Disclaimer is governed by the <strong>laws of the State of California, United States</strong>.</li>
        <li className={classes.listItem}>Any disputes or claims arising under this Disclaimer shall be resolved through <strong>binding arbitration in California</strong>.</li>
      </ul>
      <ul className={classes.list}>
        <li className={classes.listItem}><strong>Users expressly waive any right to participate in class-action lawsuits</strong> or group arbitration proceedings against Indexx.ai or its affiliates.</li>
      </ul>
     
      <h2 className={classes.subheading}>4. Contact Information</h2>
      <p className={classes.text}>
        For any questions, clarifications, or disputes related to INXC or this Disclaimer, please contact us at:
      </p>
      <p className={classes.text}><span role="img" aria-label="email">📧</span> <strong>support@indexx.ai</strong><br /><span role="img" aria-label="web">🌐</span> <strong>Indexx.ai</strong><br /><span role="img" aria-label="link">🔗</span> <a href="https://indexx.ai" className={classes.link} target="_blank" rel="noopener noreferrer">https://indexx.ai</a></p>
     
      <p className={classes.text}>
        By continuing to use the Indexx.ai asset wallet and holding any INXC Token, you confirm that you have <strong>read, understood, and agreed</strong> to the full contents of this Disclaimer and accept all associated terms, risks, and restrictions.
      </p>
    </div>
  );
  
  useEffect(() => {
    async function checkIsAuthenicated() {
      const isAuthenticated = localStorage.getItem("access_token");
      const email = localStorage.getItem("email");
      let sToken;

      if (email) {
        sToken = await getUserShortToken(email);
        setShortToken(sToken.data);
      } else if (isAuthenticated) {
        let decodedValue: any = await decodeJWT(isAuthenticated);
        sToken = await getUserShortToken(decodedValue?.email);
        setShortToken(sToken.data);
      }
    }
    checkIsAuthenicated();
  }, []);

  return (
    <>
      {isMobile ? (
        <div
          className="scan-container how-it-works flex-direction-column text-center "
          style={{ marginTop: "100px" }}
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ width: "90%", gap: "20px" }}
          >
            <Text italic strong style={{ fontSize: 50, color: "#00B64F" }}>
              Indexx
              <span style={{ fontSize: 15, marginBottom: -10 }}>&#8482;</span>
              Crypto
            </Text>
            <Text style={{ fontSize: 18, color: "var(--body_color)" }}>
              Hyper attitude, Crypto Performance.
            </Text>
            <Image
              preview={false}
              src={cryptoken}
              width={214}
              style={{ marginTop: "18px" }}
            >
              {" "}
            </Image>
            <br />
            <Text style={{ fontSize: 20, color: "var(--body_color)" }}>
              What for?
            </Text>

            <Text strong style={{ fontSize: 36, color: "#00B64F" }}>
              High Velocity, High Risk, High Reward Hyper Token
            </Text>
            <Text style={{ fontSize: 16, color: "var(--body_color)" }}>
              Investing in the nascent cryptoasset market offers massive
              potential upside, but the historic uptrend has been punctuated by
              occasional sharp <br />
              downward moves. The fund mitigates the risk partially by holding a
              diversified portfolio of cryptos.
            </Text>

            <div className="d-flex flex-column ">
              <Text
                strong
                style={{
                  fontSize: 25,
                  color: "#00B64F",
                  marginTop: 100,
                  textAlign: "left",
                }}
              >
                Long Term
              </Text>
              <Text
                strong
                style={{ fontSize: 50, color: "#00B64F", textAlign: "left" }}
              >
                Grow
              </Text>
              <Text
                style={{
                  fontSize: 17,
                  color: "var(--body_color)",
                  textAlign: "left",
                }}
              >
                The indexx crypto token aims to capture expected gains in the
                broader crypto market, which is undergoing rapid development at
                present coinciding with significant volatility and promising{" "}
                <br /> new projects constantly coming to market. By rebalancing
                regularly, the fund aims to constantly reposition in order to
                benefit from long-term market growth.
              </Text>
              <br />
              <br />
              <a
                href={
                  shortToken
                    ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=INXC`
                    : `${baseCEXURL}/update/home?buyToken=INXC`
                }
              >
                <Button
                  type="primary"
                  className="firstButton"
                  style={{ marginTop: 20, width: "100%", height: 55 }}
                >
                  {" "}
                  Buy Tokens
                </Button>
              </a>
            </div>

            <br />
            <br />
            <Image
              preview={false}
              src={cryptoken}
              width={141}
              style={{ marginTop: 100 }}
            ></Image>
            <Text style={{ fontSize: 25, color: "#00B64F" }}>
              Indexx Crypto Token price flows with top 20 Crypto Index
            </Text>
            <a
              href={
                shortToken
                  ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=INXC`
                  : `${baseCEXURL}/update/home?buyToken=INXC`
              }
              style={{ width: "100%" }}
            >
              <Button
                type="primary"
                className="firstButton"
                style={{ marginTop: 20, width: "100%", height: 55 }}
              >
                {" "}
                Today's Price
              </Button>
            </a>
            <br />
            <br />
            <br />
            <br />
            <br />

            <Text strong style={{ fontSize: 38, color: "var(--body_color)" }}>
              Advantages
            </Text>

            <div className="row">
              <div
                className="col text-left text-aline-left"
                style={{
                  textAlign: "left",
                }}
              >
                {" "}
                <br />
                <Text
                  strong
                  style={{ fontSize: 21, color: "#00B64F", textAlign: "left" }}
                >
                  Diversified cryptocurrency investment <br /> <br />
                </Text>
                <Text style={{ fontSize: 16, color: "var(--body_color)" }}>
                  This indexx crypto token holds the top 10 blue chip
                  cryptoassets, allowing the token price to track movements of
                  the broader crypto market.The token's holdings are re-balanced
                  on a weekly basis (with no asset taking up over 10%). This
                  greatly simplifies the effort required to track the broader
                  market's performance.
                </Text>
                <br></br>
              </div>
              <div
                className="col text-left text-aline-left"
                style={{
                  textAlign: "left",
                }}
              >
                {" "}
                <br /> <br />
                <Text
                  strong
                  style={{ fontSize: 21, color: "#00B64F", textAlign: "left" }}
                >
                  Due diligence
                  <br />
                </Text>
                <br />
                <Text style={{ fontSize: 16, color: "var(--body_color)" }}>
                  Our experienced and knowledgeable analyst team assesses each
                  crypto project before becoming eligible to enter the index -
                  helping avoid suspect projects that the typical investor might
                  not avoid.
                </Text>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <Image preview={false} src={left} />
                <Text
                  strong
                  style={{ fontSize: 45, color: "#00B64F", textAlign: "left" }}
                >
                  Disrupting the Global Market.
                  <br />
                </Text>
                <Text style={{ fontSize: 16, color: "var(--body_color)" }}>
                  <br />
                  Indexx crypto tokens are the world first secured token pegged
                  with world largest top 20 blue chip crypto currencies, having
                  pioneered the concept in the digital token space. A disruptor
                  to the conventional financial system and a trailblazer in the
                  digital use of traditional currency market, Indexx crypto
                  Tokens support and empower growing ventures and innovation
                  throughout the blockchain space. Indexx crypto Tokens exist as
                  a digital token built on multiple blockchains
                </Text>
              </div>
            </div>

            <div
              className="text-center center d-flex flex-column justify-content-center"
              style={{
                marginTop: 200,
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                gap: "50px",
              }}
            >
              <div
                className="col text-center center"
                style={{ textAlign: "center" }}
              >
                <Image
                  preview={false}
                  src={cryptoken}
                  width={100}
                  style={{ marginBottom: "10px" }}
                ></Image>
                <br />
                <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                  Unparalleled
                  <br /> Liquidity <br />
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: "var(--body_color)",
                  }}
                >
                  Indexx crypto tokens are among the most traded tokens in terms
                  of daily volume, offering unequalled liquidity.
                </Text>
              </div>
              <div className="col">
                <Image
                  preview={false}
                  src={cryptoken}
                  width={100}
                  style={{ marginBottom: "10px" }}
                ></Image>
                <br />
                <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                  Fully <br />
                  Transparent <br />
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: "var(--body_color)",
                  }}
                >
                  Indexx crypto stock tokens' issued and reserve assets are
                  publicly available and updated
                  <br />
                  <br />
                </Text>
              </div>
              <div className="col">
                <Image
                  preview={false}
                  src={cryptoken}
                  width={100}
                  style={{ marginBottom: "10px" }}
                ></Image>
                <br />
                <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                  Widespread <br />
                  Adoption <br />
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: "var(--body_color)",
                  }}
                >
                  Indexx crypto tokens are among the most traded tokens in terms
                  of daily volume, offering unequalled liquidity.
                </Text>
              </div>
              <div className="col">
                <Image
                  preview={false}
                  src={cryptoken}
                  width={100}
                  style={{ marginBottom: "10px" }}
                ></Image>
                <br />
                <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                  Best-in-Class <br />
                  Customer Support <br />
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: "var(--body_color)",
                  }}
                >
                  A highly-trained customer support team is ready to help you
                  24/7.
                  <br />
                  <br />
                </Text>
              </div>
            </div>

            <div
              className="text-center center d-flex flex-column justify-content-center"
              style={{
                marginTop: 50,
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                gap: "50px",
              }}
            >
              <div
                className="col text-top center"
                style={{ textAlign: "center" }}
              >
                <Image
                  preview={false}
                  src={cryptoken}
                  width={100}
                  style={{ marginBottom: "10px" }}
                ></Image>
                <br />
                <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                  Backed by Blue <br />
                  Chip 50 Crypto <br />
                  Indexx Liquidity <br />
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: "var(--body_color)",
                  }}
                >
                  <br />
                  All Indexx crypto crypto tokens are pegged at 1-to-50 with a
                  matching crypto currency and are backed 80% by blue cheap
                  crypto reserves.
                  <br />
                </Text>
              </div>
              <div className="col">
                <Image
                  preview={false}
                  src={cryptoken}
                  width={100}
                  style={{ marginBottom: "10px" }}
                ></Image>
                <br />
                <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                  Multiple <br /> Blockchains Support
                  <br />
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: "var(--body_color)",
                  }}
                >
                  <br />
                  Indexx crypto tokens are built on multiple
                  blockchains—offering easy integration and adoption. Supported
                  blockchains are Bitcoin (Omni & Liquid protocol), Ethereum,
                  TRON, EOS, Algorand, Solana, OMG Network, and Bitcoin Cash
                  (SLP).
                </Text>
              </div>
              <div className="col">
                <Image
                  preview={false}
                  src={cryptoken}
                  width={100}
                  style={{ marginBottom: "10px" }}
                ></Image>
                <br />
                <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                  Available in
                  <br /> Different Currencies
                  <br />
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: "var(--body_color)",
                  }}
                >
                  <br />
                  Indexx crypto supports US dollar (USD), euro (EUR) and
                  offshore Chinese yuan (CNH). Represented by INXC, Indexx
                  tokens are denoted as INXC in very near future.
                  <br />
                  <br />
                </Text>
              </div>
              <div className="col">
                <Image
                  preview={false}
                  src={cryptoken}
                  width={100}
                  style={{ marginBottom: "10px" }}
                ></Image>
                <br />
                <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                  Regulatory <br />
                  Compliant
                  <br />
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: "var(--body_color)",
                  }}
                >
                  <br />
                  Indexx crypto maintains world-class standardised compliance
                  measures for anti-money laundering (AML), countering the
                  financing of terrorism (CFT), sanctions, and know your
                  customer (KYC) laws and regulations.
                  <br />
                  <br />
                </Text>
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      ) : (
        <div
          className="scan-container how-it-works flex-direction-column text-center "
          style={{ marginTop: "100px" }}
        >
          <Text italic strong style={{ fontSize: 65, color: "#00B64F" }}>
            Indexx
            <span style={{ fontSize: 15, marginBottom: -10 }}>&#8482;</span>
            Crypto
          </Text>
          <br />
          <Text style={{ fontSize: 18, color: "#00B64F" }}>
            Hyper attitude, Crypto Performance.
          </Text>
          <Image
            preview={false}
            src={cryptoken}
            width={130}
            style={{ marginTop: "18px" }}
          >
            {" "}
          </Image>
          <br />
          <Text style={{ fontSize: 20, color: "#00B64F" }}>What for?</Text>

          <Text strong style={{ fontSize: 50, color: "#00B64F" }}>
            High Velocity, High Risk, High Reward Hyper Token
          </Text>
          <Text style={{ fontSize: 17, color: "#00B64F" }}>
            Investing in the nascent cryptoasset market offers massive potential
            upside, but the historic uptrend has been punctuated by occasional
            sharp <br />
            downward moves. The fund mitigates the risk partially by holding a
            diversified portfolio of cryptos.
          </Text>
          <Text strong style={{ fontSize: 50, color: "#00B64F" }}>
            Long Term Grow
          </Text>
          <Text style={{ fontSize: 17, color: "#00B64F" }}>
            The indexx crypto token aims to capture expected gains in the
            broader crypto market, which is undergoing rapid development at
            present coinciding with significant volatility and promising <br />{" "}
            new projects constantly coming to market. By rebalancing regularly,
            the fund aims to constantly reposition in order to benefit from
            long-term market growth.
          </Text>
          <br />
          <br />
          <a
            href={
              shortToken
                ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=INXC`
                : `${baseCEXURL}/update/home?buyToken=INXC`
            }
          >
            <Button type="primary" shape="round" className="firstButton">
              {" "}
              Buy Tokens
            </Button>
          </a>
          <br />
          <br />
          <Text style={{ fontSize: 25, color: "#00B64F" }}>
            Indexx Crypto Token price flows with top 20 Crypto Index
          </Text>
          <Image preview={false} src={cryptoSpin} width={100}></Image>
          <a href={`${baseDEXURL}/indexx-exchange/markets`}>
            <Button
              type="primary"
              shape="round"
              className="firstButton"
              style={{ marginTop: 25 }}
            >
              {" "}
              Today's Price
            </Button>
          </a>
          <br />
          <br />
          <br />
          <br />
          <br />

          <Text strong style={{ fontSize: 35, color: "#00B64F" }}>
            Advantages
          </Text>

          <div className="row">
            <div
              className="col-5 text-left text-aline-left"
              style={{
                paddingLeft: 100,
                paddingRight: 100,
                textAlign: "left",
                marginLeft: 200,
              }}
            >
              {" "}
              <br /> <br />
              <Text
                strong
                style={{ fontSize: 15, color: "#00B64F", textAlign: "left" }}
              >
                Diversified cryptocurrency investment <br /> <br />
              </Text>
              <Text style={{ opacity: "70%", color: "var(--body_color)" }}>
                This indexx crypto token holds the top 10 blue chip
                cryptoassets, allowing the token price to track movements of the
                broader crypto market.The token's holdings are re-balanced on a
                weekly basis (with no asset taking up over 10%). This greatly
                simplifies the effort required to track the broader market's
                performance.
              </Text>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <Image preview={false} src={left} />
            </div>
            <div
              className="col-5 text-left text-aline-left"
              style={{
                paddingLeft: 100,
                paddingRight: 100,
                textAlign: "left",
                marginLeft: -50,
              }}
            >
              {" "}
              <br /> <br />
              <Text
                strong
                style={{ fontSize: 15, color: "#00B64F", textAlign: "left" }}
              >
                Due diligence
                <br />
              </Text>
              <br />
              <Text style={{ opacity: "70%", color: "var(--body_color)" }}>
                Our experienced and knowledgeable analyst team assesses each
                crypto project before becoming eligible to enter the index -
                helping avoid suspect projects that the typical investor might
                not avoid.
              </Text>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <Text
                strong
                style={{ fontSize: 45, color: "#00B64F", textAlign: "left" }}
              >
                Disrupting the Global Market.
                <br />
              </Text>
              <Text style={{ opacity: "70%", color: "var(--body_color)" }}>
                <br />
                Indexx crypto tokens are the world first secured token pegged
                with world largest top 20 blue chip crypto currencies, having
                pioneered the concept in the digital token space. A disruptor to
                the conventional financial system and a trailblazer in the
                digital use of traditional currency market, Indexx crypto Tokens
                support and empower growing ventures and innovation throughout
                the blockchain space. Indexx crypto Tokens exist as a digital
                token built on multiple blockchains
              </Text>
            </div>
          </div>

          <div
            className="row text-center center d-flex justify-content-center"
            style={{
              marginTop: 200,
              textAlign: "center",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="col-2 text-center center"
              style={{ textAlign: "center" }}
            >
              <Image
                preview={false}
                src={cryptoken}
                width={100}
                style={{ marginBottom: "10px" }}
              ></Image>
              <br />
              <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                Unparalleled
                <br /> Liquidity <br />
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  opacity: "70%",
                  color: "var(--body_color)",
                }}
              >
                Indexx crypto tokens are among the most traded tokens in terms
                of daily volume, offering unequalled liquidity.
              </Text>
            </div>
            <div className="col-2">
              <Image
                preview={false}
                src={cryptoken}
                width={100}
                style={{ marginBottom: "10px" }}
              ></Image>
              <br />
              <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                Fully <br />
                Transparent <br />
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  opacity: "70%",
                  color: "var(--body_color)",
                }}
              >
                Indexx crypto stock tokens' issued and reserve assets are
                publicly available and updated
                <br />
                <br />
              </Text>
            </div>
            <div className="col-2">
              <Image
                preview={false}
                src={cryptoken}
                width={100}
                style={{ marginBottom: "10px" }}
              ></Image>
              <br />
              <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                Widespread <br />
                Adoption <br />
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  opacity: "70%",
                  color: "var(--body_color)",
                }}
              >
                Indexx crypto tokens are among the most traded tokens in terms
                of daily volume, offering unequalled liquidity.
              </Text>
            </div>
            <div className="col-2">
              <Image
                preview={false}
                src={cryptoken}
                width={100}
                style={{ marginBottom: "10px" }}
              ></Image>
              <br />
              <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                Best-in-Class <br />
                Customer Support <br />
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  opacity: "70%",
                  color: "var(--body_color)",
                }}
              >
                A highly-trained customer support team is ready to help you
                24/7.
                <br />
                <br />
                <br />
              </Text>
            </div>
          </div>

          <div
            className="row text-center center d-flex justify-content-center"
            style={{
              marginTop: 150,
              textAlign: "center",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="col-2 text-top center"
              style={{ textAlign: "center" }}
            >
              <Image
                preview={false}
                src={cryptoken}
                width={100}
                style={{ marginBottom: "10px" }}
              ></Image>
              <br />
              <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                Backed by Blue <br />
                Chip 50 Crypto <br />
                Indexx Liquidity <br />
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  opacity: "70%",
                  color: "var(--body_color)",
                }}
              >
                <br />
                All Indexx crypto crypto tokens are pegged at 1-to-50 with a
                matching crypto currency and are backed 80% by blue cheap crypto
                reserves.
                <br />
                <br />
                <br />
                <br />
                <br />
              </Text>
            </div>
            <br />
            <br />
            <div className="col-2">
              <Image
                preview={false}
                src={cryptoken}
                width={100}
                style={{ marginBottom: "10px" }}
              ></Image>
              <br />
              <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                Multiple <br /> Blockchains Support
                <br />
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  opacity: "70%",
                  color: "var(--body_color)",
                }}
              >
                <br />
                Indexx crypto tokens are built on multiple blockchains—offering
                easy integration and adoption. Supported blockchains are Bitcoin
                (Omni & Liquid protocol), Ethereum, TRON, EOS, Algorand, Solana,
                OMG Network, and Bitcoin Cash (SLP).
              </Text>
            </div>
            <div className="col-2">
              <Image
                preview={false}
                src={cryptoken}
                width={100}
                style={{ marginBottom: "10px" }}
              ></Image>
              <br />
              <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                Available in
                <br /> Different Currencies
                <br />
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  opacity: "70%",
                  color: "var(--body_color)",
                }}
              >
                <br />
                Indexx crypto supports US dollar (USD), euro (EUR) and offshore
                Chinese yuan (CNH). Represented by INXC, Indexx tokens are
                denoted as INXC in very near future.
                <br />
                <br />
                <br />
                <br />
              </Text>
            </div>
            <div className="col-2">
              <Image
                preview={false}
                src={cryptoken}
                width={100}
                style={{ marginBottom: "10px" }}
              ></Image>
              <br />
              <Text strong style={{ fontSize: 27, color: "#00B64F" }}>
                Regulatory <br />
                Compliant
                <br />
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  opacity: "70%",
                  color: "var(--body_color)",
                }}
              >
                <br />
                Indexx crypto maintains world-class standardised compliance
                measures for anti-money laundering (AML), countering the
                financing of terrorism (CFT), sanctions, and know your customer
                (KYC) laws and regulations.
                <br />
                <br />
                <br />
                <br />
              </Text>
            </div>
          </div>
          <br />
          <br />
        </div>
      )}
      <div style={{ marginTop: 300 }}></div>
      <Disclaimer />
      <Footer></Footer>
    </>
  );
};

export default IndexxCrypto;
